/**
 * @generated SignedSource<<4bd6c133e7a4c5412f27c31dd1ba1349>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GiftCardsModal_customer$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"GiftCardsList_customer">;
  readonly " $fragmentType": "GiftCardsModal_customer";
};
export type GiftCardsModal_customer$key = {
  readonly " $data"?: GiftCardsModal_customer$data;
  readonly " $fragmentSpreads": FragmentRefs<"GiftCardsModal_customer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GiftCardsModal_customer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GiftCardsList_customer"
    }
  ],
  "type": "Customer",
  "abstractKey": null
};

(node as any).hash = "3b23cc1094d67873b2d093072abe300e";

export default node;
